import React from 'react';
import PropTypes from 'prop-types';
import { FONT, COLOURS } from '../../constants/theme';

/**
 * SectionHeader — decorative section divider with a ✿ prefix.
 *
 * @param {object}    props
 * @param {React.ReactNode} props.children - Section title text.
 * @param {string}    [props.colour]       - Optional override colour.
 */
function SectionHeader({ children, colour }) {
  return (
    <div
      style={{
        fontFamily:    FONT,
        fontSize:      8,
        color:         colour ?? COLOURS.primary,
        borderBottom:  `2px solid ${COLOURS.borderGold}`,
        paddingBottom: 6,
        marginBottom:  10,
      }}
    >
      ✿ {children}
    </div>
  );
}

SectionHeader.propTypes = {
  children: PropTypes.node.isRequired,
  colour:   PropTypes.string,
};

SectionHeader.defaultProps = {
  colour: undefined,
};

export default SectionHeader;
